export enum TransferCardsActionTypes {
  TRANSFERRING = 'set-cards/TRANSFERRING',
  TRANSFERRED = 'set-cards/TRANSFERRED',
}
